import { mapGetters } from 'vuex'

export default (component, properties = [], variant = null) => {
  const autoComputed = {}
  properties.forEach(prop => {
    autoComputed[prop] = function() {
      return this.getVariantSettings(component, (variant || this.variant), prop)
    }
  })
  return {
    props: {
      variant: {
        type: String,
        default: 'default'
      },
    },
    computed: {
      ...mapGetters('variants', ['getVariantSettings']),
      ...autoComputed
    },
  }
}